import React from "react";

const HeroDividerBottom = () => <div className="section-hero__divider-bottom" />;

export default HeroDividerBottom;
